import { render, staticRenderFns } from "./blog-21.vue?vue&type=template&id=0194c04d&scoped=true"
import script from "./blog-21.vue?vue&type=script&lang=js"
export * from "./blog-21.vue?vue&type=script&lang=js"
import style0 from "./blog-21.vue?vue&type=style&index=0&id=0194c04d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194c04d",
  null
  
)

export default component.exports